import { RequestApiKpiBase, RequestApiPrivate } from './axios';
import { WsCode } from './wsCode';
import { withSsoAuthorization } from 'src/helpers/auth';

type AuthUser = {
  id: number;
  groups: Group;
};

type Group = {
  id: number;
  name: String;
  status: number;
};

/** `POST /generate-token` (G-Performance) — xác thực bằng SSO access token. */
export const generateGPerformanceToken = async (
  authUser: AuthUser,
  expiresAt: number,
  ssoAccessToken: string
) => {
  try {
    const payload = {
      id: authUser.id,
      groups: authUser.groups,
      expired_in: expiresAt
    };
    const { data } = await RequestApiKpiBase.post(
      WsCode.auth.generateToken,
      payload,
      withSsoAuthorization(ssoAccessToken)
    );
    RequestApiPrivate.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${data?.data?.access_token}`;
    return data;
  } catch (error) {
    throw error;
  }
};
